/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo, useCallback, useState } from 'react';

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { IconButton, OutlinedInput, OutlinedInputProps } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

type Props = OutlinedInputProps & {
  showTooltip?: string;
  hideTooltip?: string;
};

export const OutlinedPasswordInput = memo<Props>(({ showTooltip, hideTooltip, ...rest }) => {
  const [hidden, setHidden] = useState(true);

  const handleClick = useCallback(() => setHidden(prevValue => !prevValue), []);

  const PasswordVisibilityAdornment = memo(() => (
    <Tooltip title={hidden ? (showTooltip ?? '') : (hideTooltip ?? '')}>
      <IconButton onClick={handleClick} tabIndex={-1}>
        {!hidden ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  ));

  const inputType = hidden ? 'password' : 'text';

  return <OutlinedInput type={inputType} endAdornment={<PasswordVisibilityAdornment />} {...rest} />;
});
